import {
  BitwerxOffering,
  PartnerOffering,
  PartnerOfferingWithBitwerx,
} from '@v2/types';

export const parsePartnerOfferings = (
  partnerOfferings: PartnerOffering[],
  bitwerxOfferings: BitwerxOffering[]
): PartnerOfferingWithBitwerx[] => {
  return partnerOfferings.map((partnerOffering) => {
    const filteredBitwerxOfferings = bitwerxOfferings.filter((offering) =>
      partnerOffering.bitwerxOfferingIds.includes(offering.id)
    );

    const filteredWithSubOfferings = filteredBitwerxOfferings.map((offering) => ({
      ...offering,
      subOfferings: offering.subOfferings.filter((subOffering) =>
        partnerOffering.bitwerxSubOfferingIds.includes(subOffering.id)
      ),
    }));

    return {
      ...partnerOffering,
      offerings: filteredWithSubOfferings,
    };
  });
};